import { css } from "@vitality-ds/system";
export default css({
  flexShrink: 0
});